import React, { useContext, useEffect, useState } from 'react';
import { useStyles } from '../../surveyStyles';
import { Box, Paper, Typography, Card, Grid, Modal, Button } from '@mui/material';
import Images from '../../../../Assets/assetHelper';
import KenButton from '../../../../GlobalComponents/KenButton';
import BeginSurveyDialog from './BeginSurveyDialog';
import { getSurvey, postSurvey } from '../../../../Utils/apiService';
import { enqueueSnackbar } from 'notistack';
import { AuthContext } from '../../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../../interfaces/Contexts';
import BeginSurveyDynamic from './BeginSurveyDynamic';

const AllAlumniSurvey = () => {
    const classes = useStyles();
    const {
        state: { user },
        dispatch,
    } = useContext(AuthContext);
    const userData = user as AuthUser;
    const [dialogOpen, setDialogOpen] = useState(false);
    const [tookSurvey, setTookSurvey] = useState(false);
    const ismobile = window.innerWidth <= 600;
    interface SurveyQuestion {
        id: string;
        question: string;
        type: string;
        options: string[];
        required: boolean;
    }

    interface Survey {
        id: string;
        name: string;
        description: string;
        questions: SurveyQuestion[];
    }

    const [surveyData, setSurveyData] = useState<Survey[]>([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        getSurvey(userData.applicantId)
            .then((res) => {
                let surveyData = res?.data?.UnansweredSurvey || [];
                let formattedData = surveyData.map((surveyItem: any) => ({
                    id: surveyItem.survey.Id,
                    name: surveyItem.survey.Section_Name__c || surveyItem.survey.Name, // Use Section_Name__c if available, else Name
                    description: surveyItem.survey.Descripation__c || '',
                    questions: (surveyItem.surveyParams || []).map((param: any) => ({
                        id: param.Id,
                        question: param.Question_Label__c,
                        type: param.Question_Type__c,
                        options: param.MCQ_Options__c ? param.MCQ_Options__c.split(",").map((o: string) => o.trim()) : [],
                        required: param.Is_Required__c,
                        Max_Grade_Label__c: param?.Max_Grade_Label__c,
                        Min_Grade_Label__c: param?.Min_Grade_Label__c,
                        Max_Grade__c: param?.Max_Grade__c,
                        Min_Grade__c: param?.Min_Grade__c,
                    })),
                }));
                setSurveyData(formattedData);
            });
    }
    const handleCardClick = () => {
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };
    useEffect(() => {
        getSurvey(userData.applicantId)
            .then((res) => {
                let surveyData = res?.data?.UnansweredSurvey || [];
                let formattedData = surveyData.map((surveyItem: any) => ({
                    id: surveyItem.survey.Id,
                    name: surveyItem.survey.Section_Name__c || surveyItem.survey.Name,
                    description: surveyItem.survey.Descripation__c || '',
                    questions: (surveyItem.surveyParams || []).map((param: any) => ({
                        id: param.Id,
                        question: param.Question_Label__c,
                        type: param.Question_Type__c,
                        options: param.MCQ_Options__c ? param.MCQ_Options__c.split(",").map((o: string) => o.trim()) : [],
                        required: param.Is_Required__c,
                        Max_Grade_Label__c: param?.Max_Grade_Label__c,
                        Min_Grade_Label__c: param?.Min_Grade_Label__c,
                        Max_Grade__c: param?.Max_Grade__c,
                        Min_Grade__c: param?.Min_Grade__c,
                    })),
                }));
                setSurveyData(formattedData);
            });
    }, []);
    console.log('surveyData', surveyData);
    return (
        <Paper className={classes.alumniSurveyContainerMobile1} >
            <>
                <Grid container alignItems={'center'} justifyContent="space-between" >
                    <Typography className={classes.alumniCreateSurveyContainerTitle}>All surveys</Typography>
                </Grid>
                {!ismobile && (<Box mt={1} className={classes.alumniCreateSurveyContainerTitleBorder} />)}
                <Box className={`${classes.alumiBox2} scrollbar-cusgray`}>
                    <Box sx={{ paddingRight: '20px' }}>
                        <>
                            <Box className={`${classes.alumiBox2} scrollbar-cusgray`}>
                                {(surveyData).map((survey, index) => (
                                    <Card key={survey.id} sx={{ padding: '20px', marginTop: '20px', border: '1px solid #E6E6E8', borderRadius: '9px', boxShadow: 'none !important' }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 600 }}>
                                                    {survey.name}
                                                </Typography>

                                            </Grid>
                                            <Grid item xs={6} display="flex" justifyContent="end">
                                                <KenButton buttonClass={classes.beginSurveyButton1} onClick={() => { handleOpen(); setActiveIndex(index); }}>
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 500, color: "white" }}>Begin Survey</Typography>
                                                </KenButton>
                                            </Grid>
                                            <Typography sx={{ textAlign: 'left', fontSize: '12px', color: '#666', padding: "10px 16px" }}>
                                                {survey.description}
                                            </Typography>
                                        </Grid>
                                    </Card>
                                ))}
                            </Box>

                            <Modal open={open} onClose={handleClose} aria-labelledby="modal-title" aria-describedby="modal-description">
                                <>
                                    <style>
                                        {`
                          .css-1npccam {
                            width: 90% !important;
                          }
                          @media (min-width: 600px) {
                            .css-1npccam {
                              width: 60% !important;
                            }
                          }
                        `}
                                    </style>
                                    <BeginSurveyDynamic
                                        questions={surveyData?.[activeIndex]?.questions}
                                        handleClose={handleClose}
                                        activeIndex={activeIndex}
                                        userData={userData}
                                    />
                                </>
                            </Modal>
                        </>
                    </Box>
                    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <>
                            <style>
                                {`
                    .css-1npccam {
                      width: 90% !important;
                    }
                    @media (min-width: 600px) {
                      .css-1npccam {
                        width: 50% !important;
                      }
                    }
                  `}
                            </style>
                            <BeginSurveyDynamic questions={surveyData?.[activeIndex]} handleClose={handleClose} activeIndex={activeIndex} userData={userData} />
                        </>
                    </Modal>
                </Box>
            </>
        </Paper>
    );
};

export default AllAlumniSurvey;
